import "./TheArtisanalProcess.module.css";
import Header from "@/reusable_sections/Header";
import Scoop from "./sections/Scoop";
import Sourcing from "./sections/Sourcing";
import Process from "./sections/Process";
import Footer from "@/reusable_sections/Footer";
export default function TheArtisanalProcessPage() {
  return <div>
      <Header />
      <Scoop />
      <Sourcing />
      <Process />
      <Footer />
    </div>;
}